"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMART_METER_NON_COMMS_DAYS = exports.LOAD_MORE_TEST_ID = exports.LEGACY_BILLING_PERIOD_SUMMARY_TEST_ID = exports.AMOUNT_TO_LOAD = exports.INITIAL_PERIODS_TO_SHOW = void 0;
exports.INITIAL_PERIODS_TO_SHOW = 12;
exports.AMOUNT_TO_LOAD = 6;
exports.LEGACY_BILLING_PERIOD_SUMMARY_TEST_ID = 'legacyBillingPeriodSummaryTestId';
exports.LOAD_MORE_TEST_ID = 'loadMoreTestId';
exports.SMART_METER_NON_COMMS_DAYS = 5;
